// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 1423 ? "route-GuestStayPage" : chunkId) + "." + {"1423":"3975e92e","5671":"76575146","8206":"606554e3"}[chunkId] + ".chunk.css";
};